import script from "./membershipHub.vue?vue&type=script&setup=true&lang=ts"
export * from "./membershipHub.vue?vue&type=script&setup=true&lang=ts"

import "./membershipHub.vue?vue&type=style&index=0&id=9517beda&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9517beda"]])

export default __exports__